const PREFIX_COOKIE = 'STRATEGY_COOKIE_'
import Cookies from 'js-cookie'
import enviroment from '../enviroment';

export default {
    get(name) {
        return Cookies.get(PREFIX_COOKIE + name)
    },
    set(name, value) {
        Cookies.set(PREFIX_COOKIE + name, value, {
            domain: enviroment.cookiesDomain,
            path: '/'
        })
    },
}